<div class="main-header-left d-none d-lg-block">
  <div class="logo-wrapper"><a href="javascript:void(0)"><img width="196" height="80" src={{logo}}
        alt=""></a></div>
</div>
<div class="sidebar custom-scrollbar">
  <div class="sidebar-user text-center">
    <div><img class="img-60 rounded-circle" [src]="url? url:[urlImagen]" alt="#">
      <div class="profile-edit"><a>
          <i class="icofont icofont-pencil-alt-5"><input class="upload" type="file" (change)="readUrl($event)" /></i>
        </a></div>
    </div>
    <h6 class="mt-3 f-14"> {{nombreUsuario}}</h6>
    <p>{{ nombreEmpresa }}</p>
  </div>
  <ul class="sidebar-menu">
    <li *ngFor="let menuItem of menuItems" [ngClass]="{active: menuItem.active}">
      <!-- Sub -->
      <a href="javascript:void(0)" class="sidebar-header" *ngIf="menuItem.type === 'sub'"
        (click)="toggletNavActive(menuItem)">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
            class="badge badge-{{menuItem.badgeType}} ml-3"
            *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right" *ngIf="menuItem.children"></i>
      </a>
      <!-- Link -->
      <a [routerLink]="!menuItem.type ? null : [menuItem.path]" routerLinkActive="active" class="sidebar-header"
        *ngIf="menuItem.type === 'link'">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
            class="badge badge-{{menuItem.badgeType}} ml-3"
            *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right" *ngIf="menuItem.children"></i>
      </a>
      <!-- External Link -->
      <a href="{{ !menuItem.type ? null : menuItem.path }}" class="sidebar-header" *ngIf="menuItem.type === 'extLink'">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
            class="badge badge-{{menuItem.badgeType}} ml-3"
            *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right" *ngIf="menuItem.children"></i>
      </a>
      <!-- External Tab Link -->
      <a href="{{ !menuItem.type ? null : menuItem.path }}" target="_blank" class="sidebar-header"
        *ngIf="menuItem.type === 'extTabLink'">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
            class="badge badge-{{menuItem.badgeType}} ml-3"
            *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right" *ngIf="menuItem.children"></i>
      </a>
      <!-- 2nd Level Menu -->
      <ul class="sidebar-submenu" [ngClass]="{'menu-open': menuItem.active, 'menu-close': !menuItem.active }"
        *ngIf="menuItem.children">
        <li *ngFor="let childrenItem of menuItem.children" [ngClass]="{active: childrenItem.active}">
          <!-- Sub -->
          <a href="javascript:void(0)" *ngIf="childrenItem.type === 'sub'" (click)="toggletNavActive(childrenItem)">
            <i class="fa fa-circle"></i>{{childrenItem.title}} <span
              class="badge badge-{{childrenItem.badgeType}} pull-right"
              *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span>
            <i class="fa fa-angle-down pull-right" *ngIf="childrenItem.children"></i>
          </a>
          <!-- Link -->
          <a [routerLink]="!childrenItem.type ? null : [childrenItem.path]" *ngIf="childrenItem.type === 'link'"
            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <i class="fa fa-circle"></i>{{childrenItem.title}} <span
              class="badge badge-{{childrenItem.badgeType}} pull-right"
              *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span>
            <i class="fa fa-angle-down pull-right" *ngIf="childrenItem.children"></i>
          </a>
          <!-- External Link -->
          <a href="{{ !childrenItem.type ? null : childrenItem.path }}" *ngIf="childrenItem.type === 'extLink'"
            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <i class="fa fa-circle"></i>{{childrenItem.title}} <span
              class="badge badge-{{childrenItem.badgeType}} pull-right"
              *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span>
            <i class="fa fa-angle-down pull-right" *ngIf="childrenItem.children"></i>
          </a>
          <!-- External Tab Link -->
          <a href="{{ !childrenItem.type ? null : childrenItem.path }}" target="_blank"
            *ngIf="childrenItem.type === 'extTabLink'">
            <i class="fa fa-circle"></i>{{childrenItem.title}} <span
              class="badge badge-{{childrenItem.badgeType}} pull-right"
              *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span>
            <i class="fa fa-angle-down pull-right" *ngIf="childrenItem.children"></i>
          </a>
          <!-- 3rd Level Menu -->
          <ul class="sidebar-submenu" *ngIf="childrenItem.children">
            <li *ngFor="let childrenSubItem of childrenItem.children">
              <!-- Link -->
              <a [routerLink]="!childrenSubItem.type ? null : [childrenSubItem.path]"
                *ngIf="childrenSubItem.type === 'link'" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-circle"></i>{{childrenSubItem.title}} <span
                  class="badge badge-{{childrenSubItem.badgeType}} pull-right"
                  *ngIf="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span>
              </a>
              <!-- External Link -->
              <a href="{{ !childrenSubItem.type ? null : childrenSubItem.path }}"
                *ngIf="childrenSubItem.type === 'extLink'" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-circle"></i>{{childrenSubItem.title}} <span
                  class="badge badge-{{childrenSubItem.badgeType}} pull-right"
                  *ngIf="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span>
              </a>
              <!-- External Tab Link -->
              <a href="{{ !childrenSubItem.type ? null : childrenSubItem.path }}" target="_blank"
                *ngIf="childrenSubItem.type === 'extTabLink'">
                <i class="fa fa-circle"></i>{{childrenSubItem.title}} <span
                  class="badge badge-{{childrenSubItem.badgeType}} pull-right"
                  *ngIf="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>

  <div class="sidebar-user text-center">
  <form id="frm_ePaycoCheckoutOpen" name="frm_ePaycoCheckoutOpen" method="POST"
    action="https://secure.payco.co/checkoutopen.php">

    <input name="p_cust_id_cliente" type="hidden" value="50256" />
    <input name="p_key" type="hidden" value="e91411d8384df71ec151cc124695665487346249" />
    <input name="p_id_factura" type="hidden" value="" />
    <input name="p_description" type="hidden" value="Servicios de AdentLab (Todo lo relacionado con AdentLab, Servicio, Factura Electronica, Etiquetas, Impresoras, Escaner, ETC)" />
    <input name="p_detalle" type="hidden"
      value="" />
    <input name="p_referencia" type="hidden" value="Numero Cedula o Nit" />
    <input name="p_test_request" type="hidden" value="false" />
    <input name="p_url_respuesta" type="hidden" value="" />
    <input name="p_url_confirmacion" type="hidden" value="" />
    <input type="image" id="imagen" src="https://multimedia.epayco.co/dashboard/btns/btn7.png" alt=""
      (click)="abripaguina($event)" />
    <input type="hidden" id="idboton" name="idboton" value="46432" />

  </form> <!-- ================================================================== -->

</div>

</div>